import axios from "axios";
import store from "@/store";

/**
 * Create an instance custom of Axios
 */
const api = axios.create({
    // baseURL can be updated for development purposes, for example to connect to a different backend
    baseURL: process.env.VUE_APP_API_BASE_URL || "",
});

/**
 * Infuse the JWT token in every request by default
 */
api.defaults.headers.common["Authorization"] = `Bearer ${window.localStorage.getItem(
    "leapsomeImpersonationToken",
) || window.localStorage.getItem("leapsomeToken")}`;

/**
 * Add interceptors for global error handling
 */
api.interceptors.response.use(
    res => res,
    async err => {
        const isInAuthProcess =
            ["/api/users/auth/local", "/api/users/auth/token", "/api/users/auth/identify"].includes(
                err?.response?.config?.url,
            ) || err?.response?.config?.url.startsWith("/api/users/get/invite");

        // 401
        //
        // Remove JWTs from localStorage
        // Redirect the user to the login screen
        //
        if (err?.response?.status === 401 && !isInAuthProcess) {
            await store.dispatch("auth/logout");
            return Promise.reject(err);
        }

        // Generic
        //
        return Promise.reject(err);
    },
);

export default api;
